import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Toast, ToastContainer, Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./LoginSignup.css";
import { BASE_URL } from '../../constants';
import logo from "../assets/developiaLogo.png"
import favicon from "../assets/favicon.svg"
import { apiFetch } from "../../utils/apiFetch";

function LoginSignup() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [showResetModal, setShowResetModal] = useState(false);
  const [resetUsername, setResetUsername] = useState('');
  const [resetCode, setResetCode] = useState('');
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [maskedEmail, setMaskedEmail] = useState('');

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("danger");

  const navigate = useNavigate();

  const triggerToast = (msg, variant = "danger") => {
    setToastMessage(msg);
    setToastVariant(variant);
    setShowToast(true);
  };

  const maskEmail = (email) => {
    if (!email || !email.includes('@')) return "";
    const [name, domain] = email.split('@');
    if (name.length <= 2) return `${name[0]}*@${domain}`;
    const maskedName = name[0] + "*".repeat(name.length - 2) + name.slice(-1);
    return `${maskedName}@${domain}`;
  };

  const handleRequestCode = async () => {
    if (!resetUsername) {
      triggerToast("Zəhmət olmasa istifadəçi adını daxil edin");
      return;
    }
    setResetLoading(true);
    const payload = {
      id: 0, name: "", surname: "", username: resetUsername, email: "",
      phone: "", phoneHome: "", phoneWhatsApp: "", address: "",
      userType: "", code: "", imageFileId: 0,
      birthday: new Date().toISOString(), gender: "", courseId: 0, passwordIsOk: false
    };
    try {
      const res = await apiFetch(BASE_URL + '/users/reset-password-get-code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'accept': '*/*' },
        body: JSON.stringify(payload)
      });
      if (res.ok) {
        const data = await res.json();
        if (data && data.email) setMaskedEmail(maskEmail(data.email));
        triggerToast("Yeni kod mail ünvanınıza göndərildi", "success");
        setIsCodeSent(true);
      }
    } catch {
      triggerToast("Serverlə əlaqə kəsildi");
    } finally {
      setResetLoading(false);
    }
  };

  const handleVerifyCode = async () => {
    if (!resetCode) {
      triggerToast("Zəhmət olmasa kodu daxil edin");
      return;
    }
    setResetLoading(true);
    const payload = {
      id: 0, name: "", surname: "", username: resetUsername, email: "",
      phone: "", phoneHome: "", phoneWhatsApp: "", address: "",
      userType: "", code: resetCode,
      imageFileId: 0, birthday: new Date().toISOString(),
      gender: "", courseId: 0, passwordIsOk: false
    };
    try {
      const res = await apiFetch(BASE_URL + '/users/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'accept': '*/*' },
        body: JSON.stringify(payload)
      });
      if (res.ok) {
        triggerToast("Yeni şifrə mail ünvanınıza göndərildi", "success");
        setShowResetModal(false);
        setIsCodeSent(false);
        setResetCode('');
        setResetUsername('');
      }
    } catch {
      triggerToast("Server xətası baş verdi");
    } finally {
      setResetLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const credentials = `${username}:${password}`;
    const basicToken = btoa(unescape(encodeURIComponent(credentials)));
    try {
      const validateRes = await fetch(BASE_URL + '/users/validate', {
        method: 'GET',
        headers: { accept: "*/*", Authorization: `Basic ${basicToken}` }
      });
      if (!validateRes.ok) {
        triggerToast("İstifadəçi adı və ya şifrə yanlışdır");
        setLoading(false);
        return;
      } else {
        const validateData = await validateRes.json();
        if (validateData.grants.includes("ROLE_SHOW_ORGANIZATION_TRAININGS")) {
          localStorage.setItem("showSyllabus", true);
        }
      }

      const userRes = await apiFetch(BASE_URL + '/users/get-user-object', {
        headers: { accept: "*/*", Authorization: `Basic ${basicToken}` }
      });
      if (!userRes.ok) {
        setLoading(false);
        return;
      }

      const user = await userRes.json();
      if (user.type !== "teacher") {
        triggerToast("Sizin statusunuz bu səhifəyə daxil olmağa uyğun deyil");
        setLoading(false);
        return;
      }

      localStorage.setItem("teacher_authToken", basicToken);
      localStorage.setItem("userData", JSON.stringify(user));
      triggerToast("Giriş uğurludur!", "success");
      setTimeout(() => navigate('/main'), 800);
    } catch {
      triggerToast("Server xətası baş verdi");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-card">

      <div className="login-brand">
        <img src={logo} alt="Developia Logo" className="login-logo" />
        <div className="login-portal-badge">
          <img src={favicon} alt="" style={{ width: 15, height: 15 }} />
          Müəllim Portalı
        </div>
      </div>

      <div className="login-divider" />

      <form onSubmit={handleSubmit} className="login-form">
        <div className="login-field">
          <label htmlFor="username">İstifadəçi adı</label>
          <div className="login-input-wrap">
            <i className="bi bi-person"></i>
            <input type="text" id="username" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="istifadəçi adınız" required />
          </div>
        </div>
        <div className="login-field">
          <label htmlFor="password">Şifrə</label>
          <div className="login-input-wrap">
            <i className="bi bi-lock"></i>
            <input type={showPassword ? 'text' : 'password'} id="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
            <i
              className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}
              onClick={() => setShowPassword(p => !p)}
              style={{ cursor: 'pointer', color: '#9ca3af' }}
            />
          </div>
        </div>
        <button type="submit" className="login-btn-primary" disabled={loading}>
          {loading
            ? <><i className="bi bi-arrow-clockwise login-spin"></i> Yüklənir...</>
            : <><i className="bi bi-box-arrow-in-right"></i> Giriş et</>}
        </button>
        <button type="button" className="login-btn-ghost" onClick={() => setShowResetModal(true)}>
          <i className="bi bi-key"></i> Şifrəmi unutmuşam
        </button>
      </form>

      <Modal show={showResetModal} onHide={() => { setShowResetModal(false); setIsCodeSent(false); }} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '16px', fontWeight: 'bold' }}>Şifrənin bərpa edilməsi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!isCodeSent ? (
            <div className="mb-3">
              <label className="form-label">İstifadəçi adı:</label>
              <input type="text" className="form-control" value={resetUsername} onChange={(e) => setResetUsername(e.target.value)} />
              <p className="mt-3" style={{ fontSize: '13px', color: '#6c757d' }}>
                İstifadəçi adınızı daxil edin və Bərpa et düyməsinə klik edin. Email ünvanınıza kod göndəriləcək.
              </p>
            </div>
          ) : (
            <div className="mb-3">
              <label className="form-label">Kod:</label>
              <input type="text" className="form-control" value={resetCode} onChange={(e) => setResetCode(e.target.value)} />
              <p className="mt-3" style={{ fontSize: '13px', color: '#6c757d' }}>
                Bərpa kodunuz bu emailə göndərildi: <br />
                <strong>{maskedEmail}</strong>
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          {!isCodeSent ? (
            <Button variant="success" onClick={handleRequestCode} disabled={resetLoading} style={{ backgroundColor: '#198754' }}>
              {resetLoading ? "Göndərilir..." : "Bərpa et"}
            </Button>
          ) : (
            <Button variant="success" onClick={handleVerifyCode} disabled={resetLoading} style={{ backgroundColor: '#198754' }}>
              {resetLoading ? "Təsdiqlənir..." : "Təsdiq et"}
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <ToastContainer position="bottom-end" className="p-3" style={{ zIndex: 1100 }}>
        <Toast onClose={() => setShowToast(false)} show={showToast} delay={4000} autohide bg={toastVariant}>
          <Toast.Header closeButton={false}><strong className="me-auto">Sistem Mesajı</strong></Toast.Header>
          <Toast.Body className="text-white">{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

    </div>
  );
}

export default LoginSignup;
